import { useStaticQuery, graphql } from "gatsby";

interface UseLocationsData {
  allWpLocation: {
    nodes: Location[];
  };
  allWpGeoLocation: {
    nodes: GeoLocation[];
  };
}

export const useLocations = (): {
  locations: Location[];
  reservations: Location[];
  geoLocations: GeoLocation[];
} => {
  const data: UseLocationsData = useStaticQuery(graphql`
    query useLocations {
      allWpLocation {
        nodes {
          title
          slug
          id
          locationReservation {
            locationReservationToggler
            widgetSupplier
            widgetScriptUrl
          }
          locationPage {
            pageLocationToggler
          }
          geoLocations {
            nodes {
              slug
              name
            }
          }
        }
      }
      allWpGeoLocation {
        nodes {
          slug
          name
        }
      }
    }
  `);

  const locations = data.allWpLocation.nodes.filter(
    (location) => location.locationPage.pageLocationToggler === true
  );

  const geoLocations = data.allWpGeoLocation.nodes;

  // Filter locations with locationReservationToggler
  const reservations = data.allWpLocation.nodes.filter(
    (location) =>
      location.locationReservation.locationReservationToggler === true
  );

  return { locations, geoLocations, reservations }; // Add this line
};
